module.exports = __webpack_public_path__ + "static/media/netflix.e8ae32d3.mp3";